var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.332,
    height: 19.332,
    viewBox: "0 0 19.332 19.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Smile",
    d: "M12,2.388h0A9.612,9.612,0,1,0,21.612,12h0A9.623,9.623,0,0,0,12,2.388Zm4.428,12.169h0a.613.613,0,0,0-1.061-.613h0a3.889,3.889,0,0,1-6.736,0h0a.613.613,0,0,0-1.06.613h0a5.114,5.114,0,0,0,8.857,0ZM12,20.388a8.4,8.4,0,1,1,5.928-2.459A8.387,8.387,0,0,1,12,20.388ZM7.8,9.576a.988.988,0,1,0,.443-.364A.988.988,0,0,0,7.8,9.576Zm6.75,0A.987.987,0,1,0,15,9.213.988.988,0,0,0,14.554,9.576Z",
    transform: "translate(-2.33 -2.338)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/Smile.3c833b898a11d208a2149bc2c7b268c7.svg";
export { ForwardRef as ReactComponent };